const authenticatedRoutes = [
    '/profile',
    '/create',
    '/api-keys',
    '/template',
    '/wallet',
    '/api-keys',
    '/issues',
    '/transactions'
]
export default authenticatedRoutes;